import isNil from 'lodash-es/isNil';
import { useClient } from '../../ClientProvider';
import { OptionCode } from '../../enums';
import useQuery from '../../useQuery';
export const OTHER_SEED_REF = '0';
const EMPTY_SEEDS = [];
export const useSeedsOptions = (activeOptions) => {
    const client = useClient();
    const optionCode = activeOptions.includes(OptionCode.waterBalanceRI)
        ? OptionCode.waterBalanceRI
        : activeOptions.includes(OptionCode.waterBalance)
            ? OptionCode.waterBalance
            : activeOptions.includes(OptionCode.maizy)
                ? OptionCode.maizy
                : OptionCode.cropTracking;
    const seeds = useQuery(client.seeds.getAll({ optionCode }));
    const notNullSeeds = seeds.data ?? EMPTY_SEEDS;
    const otherSeed = notNullSeeds.find(({ refWeenat }) => refWeenat === OTHER_SEED_REF);
    const options = notNullSeeds
        .map(({ id, localizedName, name, vendor }) => {
        return {
            value: id,
            label: optionCode === OptionCode.maizy
                ? `${name} ${vendor}`
                : !isNil(localizedName)
                    ? localizedName
                    : '-'
        };
    })
        .sort((a, b) => a.label.localeCompare(b.label));
    return { options, otherSeed };
};
